import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import localforage from 'localforage';
import { persistCache } from 'apollo-cache-persist';

function getGraphqlUri() {
  try {
    const base = typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL;
    if (base) return new URL('graphql', base).href;
  } catch (_) {}
  return '/graphql';
}

/**
 * Ensures fetch always returns a real Response to apollo-link-http.
 * Otherwise parseAndCheckHttpResponse can throw "Cannot read properties of undefined (reading 'status')".
 */
function safeFetch(input, init) {
  return fetch(input, init).then((response) => {
    if (response == null || typeof response.text !== 'function') {
      return Promise.reject(
        new TypeError(
          'Invalid network response. Check that the API is reachable and CORS allows this origin.',
        ),
      );
    }
    return response;
  });
}

const httpLink = createHttpLink({
  uri: getGraphqlUri(),
  fetch: safeFetch,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('auth_token');
  return {
    headers: { ...headers, authorization: token ? `Bearer ${token}` : '' },
  }
});

localforage.config({
  name: 'SC-data',
  size: 31457280,
});

const cache = new InMemoryCache();

persistCache({
  cache,
  storage: localforage,
  maxSize: 31457280,
});

export default new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});
